import L from "leaflet";
import { createControlComponent } from "@react-leaflet/core";

import "leaflet-routing-machine";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.js";

const createRoutineMachineLayer = (props) => {
	const { waypoints } = props;

	const destinationIcon = L.divIcon({
		html: `
		<svg xmlns="http://www.w3.org/2000/svg" width="43.144" height="56.365" viewBox="0 0 43.144 56.365">
  <g id="Group_34" data-name="Group 34" transform="translate(-217.054 -818.5)">
    <path id="Path_7" data-name="Path 7" d="M21.072,0A21.072,21.072,0,0,1,42.144,21.072c0,11.638-12.132,23.983-21.072,34.057C13.5,47.293,0,32.709,0,21.072A21.072,21.072,0,0,1,21.072,0Z" transform="translate(217.554 819)" fill="${props.color}" stroke="${props.color}" stroke-width="1"/>
    <path id="icons8-exterior" d="M11.793,1a.45.45,0,0,0-.262.1L2.541,8.132,1.172,9.2a.45.45,0,1,0,.556.709l.623-.487V21.267a.45.45,0,0,0,.45.45H12.71a.45.45,0,0,0,.45-.45V14.962h3.6v6.305a.45.45,0,0,0,.45.45h3.6a.45.45,0,0,0,.45-.45V9.424l.623.487a.45.45,0,1,0,.556-.709L21.1,8.151,12.087,1.1A.45.45,0,0,0,11.793,1Zm.016,1.022,8.557,6.7v12.1h-2.7V14.511a.45.45,0,0,0-.45-.45h-4.5a.45.45,0,0,0-.45.45v6.305H3.252V8.719ZM6.4,9.557a.45.45,0,0,0-.45.45v3.6a.45.45,0,0,0,.45.45h3.6a.45.45,0,0,0,.45-.45v-3.6a.45.45,0,0,0-.45-.45Zm.45.9h2.7v2.7h-2.7Z" transform="translate(226.816 826.257)" fill="#fff"/>
  </g>
</svg>
`,
	className: "",
	iconSize: [43.144, 56.365],
	//iconAnchor: [43.144, 56.365],
	  });

	const sourceIcon = L.divIcon({
		html: `
		<svg xmlns="http://www.w3.org/2000/svg" width="43.144" height="56.365" viewBox="0 0 43.144 56.365">
  <g id="Group_43" data-name="Group 43" transform="translate(-156.054 -893.5)">
    <path id="Path_5" data-name="Path 5" d="M21.072,0A21.072,21.072,0,0,1,42.144,21.072c0,11.638-12.132,23.983-21.072,34.057C13.5,47.293,0,32.709,0,21.072A21.072,21.072,0,0,1,21.072,0Z" transform="translate(156.554 894)" fill="${props.color}" stroke="${props.color}" stroke-width="1"/>
    <g id="surface1" transform="translate(165.631 904.891)">
      <path id="Path_6" data-name="Path 6" d="M25.9,6H4.09A1.09,1.09,0,0,0,3,7.09V25.627a1.09,1.09,0,0,0,1.09,1.09H25.9a1.09,1.09,0,0,0,1.09-1.09V7.09A1.09,1.09,0,0,0,25.9,6ZM20.446,7.09h2.181v1.09H20.446Zm0,6.815a1.363,1.363,0,1,1-1.363-1.363A1.362,1.362,0,0,1,20.446,13.905ZM17.175,7.09h2.181v1.09H17.175Zm-3.271,0h2.181v1.09H13.9Zm-3.271,0h2.181v1.09H10.633Zm-3.271,0H9.542v1.09H7.361ZM4.09,10.361h1.09v2.181H4.09Zm0,3.271h1.09v2.181H4.09Zm0,3.271h1.09v2.181H4.09Zm0,3.271h1.09v2.181H4.09Zm2.181,5.452H4.636a.545.545,0,0,1-.545-.545V23.446h1.09v1.09h1.09Zm0-17.446H5.181v1.09H4.09V7.636a.545.545,0,0,1,.545-.545H6.271ZM9.542,25.627H7.361v-1.09H9.542Zm3.271,0H10.633v-1.09h2.181Zm3.271,0H13.9v-1.09h2.181Zm3.271,0H17.175v-1.09h2.181Zm3.271,0H20.446v-1.09h2.181Zm.488-6.3a.543.543,0,0,1-.73.245l-3.028-1.514-3.028,1.514a.545.545,0,0,1-.669-.147l-3.936-4.919L7.787,19.425a.545.545,0,1,1-.852-.681L11.3,13.292a.563.563,0,0,1,.852,0L16.236,18.4l2.877-1.437a.545.545,0,0,1,.488,0L22.872,18.6A.545.545,0,0,1,23.114,19.327ZM25.9,25.081a.545.545,0,0,1-.545.545H23.717v-1.09h1.09v-1.09H25.9Zm0-2.726h-1.09V20.175H25.9Zm0-3.271h-1.09V16.9H25.9Zm0-3.271h-1.09V13.633H25.9Zm0-3.271h-1.09V10.361H25.9Zm0-3.271h-1.09V8.181h-1.09V7.09h1.636a.545.545,0,0,1,.545.545Z" transform="translate(-3 -6)" fill="#fff"/>
    </g>
  </g>
</svg>`,
	className: "",
	iconSize: [43.144, 56.365],
	//iconAnchor: [43.144, 56.365],
	}); 
	
	const instance = L.Routing.control({
		waypoints,
		lineOptions: {
			styles: [{ color: props.color, weight: 4 }]
		},
		altLineOptions: {
			styles: [{ color: "#CCCCCC", weight: 4 }]
		},
		showAlternatives: true,
		routeWhileDragging: true,
		geometryOnly: false,
		show:false,
		language: props.lang,
		createMarker: function (i, waypoint, n) {
			// console.log(i, waypoint, n);
            const marker = L.marker(waypoint.latLng, {
              draggable: i === 0 ? true : false,
             /* 
			  bounceOnAdd: true,
              bounceOnAddOptions: {
                duration: 1000,
                height: 800,
                function() {
                  //(bindPopup(myPopup).openOn(map))
                }
              },
			  */
              icon: i === 0 ? sourceIcon : destinationIcon
            });
            return marker;
        },
		summaryTemplate: '<div class="routing_title"><h3>{name}</h3><h5>{distance}, {time}</h5></div>'
	});

	L.DomEvent.on(instance, 'routeselected', function(e) {
		// console.log("routeselected=",e);
	});

	L.DomEvent.on(instance, 'routesfound', function(e) {
		//console.log("routesfound=",e);
	});

	

	return instance;
};

const RoutingMachine = createControlComponent(createRoutineMachineLayer);

export default RoutingMachine;